var React = require("react");
const Carousel = require('nuka-carousel').default
var ApplicationContext = require("../config/ApplicationContext.js");
var EditorLaunchUtil = require("../util/EditorLaunchUtil.js");

const TOTAL_PAGES = 4;

class CarouselList extends React.Component {

    constructor(props) {
        super(props);
        this.state = { slideIndex: 0, autoplay: true };
        this.classRowLeft = "carousel__arrow";
        this.clasRowRight = "carousel__arrow right";
        this.linkPackage = ApplicationContext.getPackageEditor();
        this.afterSlide = this.afterSlide.bind(this);
    }

    afterSlide(slideIndex) {
        this.moveSelector(slideIndex);
        this.setState({ slideIndex: slideIndex, autoplay: this.state.autoplay });
    }

    nextSlide(type = "left") {
        var slideIndex = this.state.slideIndex;
        switch (true) {
            case type === "right":
                slideIndex++;
                if (slideIndex >= TOTAL_PAGES) {
                    slideIndex = 0;
                }
                this.setState({ slideIndex: slideIndex, autoplay: false });

                break;
            case type === "left":
                slideIndex--;
                if (slideIndex < 0 ) {
                    slideIndex = TOTAL_PAGES - 1;
                }
                this.setState({ slideIndex: slideIndex, autoplay: false });
                break;
        }
    }

    moveSelector(slideIndex) {
        let elemt = "";
        switch (slideIndex) {
            case 0: elemt = "create"; break;
            case 1: elemt = "use"; break;
            case 2: elemt = "sync"; break;
            case 3: elemt = "export"; break;
        }
        let calc = this[elemt].getBoundingClientRect().x - this.contPointer.getBoundingClientRect().x;
        this.pointer.style.transform = `translateX(${calc}px)`;
        this.pointer.style.width = `${this[elemt].clientWidth}px`;
    }

    render() {

        let classCreate = this.state.slideIndex === 0 ? "carousel__list__option active" : "carousel__list__option";
        let classUse = this.state.slideIndex === 1 ? "carousel__list__option active" : "carousel__list__option";
        let classSync = this.state.slideIndex === 2 ? "carousel__list__option active" : "carousel__list__option";
        let classExport = this.state.slideIndex === 3 ? "carousel__list__option active" : "carousel__list__option";

        return (
            <div className="container carousel" onMouseEnter={() => this.setState({ autoplay: false })} onMouseLeave={() => this.setState({ autoplay: true })}>
                <div className={this.classRowLeft} onClick={() => this.nextSlide("left")}>
                    <img src={ApplicationContext.assetUrlPrefix + "/assets/home/carousel-left.svg"} />
                </div>
                <div className={this.clasRowRight} hidden={this.setState.slideIndex == 3} onClick={() => this.nextSlide("right")}>
                    <img src={ApplicationContext.assetUrlPrefix + "/assets/home/carousel-left.svg"} />
                </div>

                <div className="carousel__list" ref={div => this.contPointer = div}>
                    <div className={classCreate} ref={div => this.create = div} onClick={() => this.setState({ slideIndex: 0 })}>Create</div>
                    <div className={classUse} ref={div => this.use = div} onClick={() => this.setState({ slideIndex: 1 })} >Use</div>
                    <div className={classSync} ref={div => this.sync = div} onClick={() => this.setState({ slideIndex: 2 })}>Sync</div>
                    <div className={classExport} ref={div => this.export = div} onClick={() => this.setState({ slideIndex: 3 })}>Export</div>
                    <div className="carousel__list__pointer" ref={div => this.pointer = div}></div>
                </div>

                <div>
                    <Carousel autoplayInterval={5000}
                        afterSlide={this.afterSlide}
                        autoplay={this.state.autoplay}
                        wrapAround={true}
                        slideIndex={this.state.slideIndex}>
                        <div className="carousel__container">
                            <img className="carousel__container__preview" src={ApplicationContext.assetUrlPrefix + "/assets/home/ipc_generator.gif"} />
                            <div className="carousel__container__info">
                                <h2 className="carousel__container__info__title">Create manufacturing-ready footprints & 3D models*</h2>
                                <p>Instantly generate PCB packages by entering a few dimensions from a data sheet.
                                </p>
                                <p className="disclaimer">*Footprint pad geometries are generated to meet IPC-7351B standards.  Always verify components prior to manufacturing.</p>
                                <a className="carousel__container__info__create button" href={EditorLaunchUtil.editorUrl(this.linkPackage, {})} target="_blank">
                                    <p onClick={() => this.props.onSendGoogleGA("home", "createPackage")}>Create a package</p>
                                </a>
                            </div>
                        </div>
                        <div className="carousel__container">
                            <img className="carousel__container__preview" src={ApplicationContext.assetUrlPrefix + "/assets/home/autorouter.gif"} />
                            <div className="carousel__container__info">
                                <h2 className="carousel__container__info__title">Use your packages in Autodesk Fusion Libraries</h2>
                                <p>Incorporate packages into your Fusion Electronics libraries and use them in your next PCB design.</p>
                            </div>
                        </div>
                        <div className="carousel__container">
                            <img className="carousel__container__preview" src={ApplicationContext.assetUrlPrefix + "/assets/home/push_to_library_io.gif"} />
                            <div className="carousel__container__info">
                                <h2 className="carousel__container__info__title">Sync your libraries with Autodesk Fusion</h2>
                                <p>Use library.io cloud to share your libraries across Autodesk Fusion Team hubs.</p>
                            </div>
                        </div>
                        <div className="carousel__container">
                            <img className="carousel__container__preview" src={ApplicationContext.assetUrlPrefix + "/assets/home/export.gif"} />
                            <div className="carousel__container__info">
                                <h2 className="carousel__container__info__title">Export and use everywhere</h2>
                                <p>Libraries and 3D models from library.io can be exported to use in your preferred CAD system.</p>
                            </div>
                        </div>
                    </Carousel>
                </div>
            </div>
        );
    }
}

module.exports = CarouselList;
